import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import { signInReset } from '@zocdoc-frontend-common/components-sign-in-form/signInFormActions';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { SignInDropdown } from './SignInDropdownView';

const mapDispatchToProps = {
    resetLoginModal: signInReset,
};

export default flowRight(
    withCustomMetrics({
        component: 'SignInDropdown',
    }),
    connect(null, mapDispatchToProps)
)(SignInDropdown);
